<template>
  <div
    id="reports"
    class="row"
  >
    <div class="col-12">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="reset"
        @keydown="form.onKeydown($event)"
      >
        <v-container grid-list-xl>
          <v-toolbar
            flat
            :color="themeColor"
          >
            <v-toolbar-title class="white--text">REPORTE DE TRANSACCIONES</v-toolbar-title>
          </v-toolbar>
          <v-layout
            :id="ref"
            class="wrap justify-space-around form-body"
          >
            <v-col
              lg="4" md="6" sm="6" cols="12"
            >
              <v-select
                v-model="form.licenceType"
                :items="licenceTypes"
                :rules="[rules.required]"
                label="Tipo de Reporte"
                required
              />
            </v-col>
            <v-col
              lg="4" md="6" sm="6" cols="12"
            >
              <v-menu
                v-model="startMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="form.dateStart"
                    label="Fecha Inicio"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  :color="themeColor"
                  v-model="form.dateStart"
                  @input="startMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col
              lg="4" md="6" sm="6" cols="12"
            >
              <v-menu
                v-model="endMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="form.dateEnd"
                    label="Fecha Fin"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  :color="themeColor"
                  v-model="form.dateEnd"
                  @input="endMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col
              lg="3" md="6" sm="6" cols="12"
            >
              <v-select
                v-model="form.estado"
                :items="estados"
                label="Estado"
              />
            </v-col>
            <v-col
              lg="3" md="6" sm="6" cols="12"
              v-if="form.licenceType != 4"
            >
              <v-select
                v-model="form.service_id"
                :items="licenciasAll"
                item-value="id"
                item-text="nombre"
                label="Servicios"
                placeholder="Todas"
              />
            </v-col>
            <v-col
              lg="3" md="6" sm="6" cols="12"
              v-if="form.licenceType == 1 || form.licenceType == 4"
            >
              <v-text-field
                v-model="form.rucCompany"
                :rules="[rules.rucLength, rules.rucFormat]"
                label="RUC Empresa"
                maxlength="20"
              />
            </v-col>
            <v-col
              lg="3" md="6" sm="6" cols="12"
              v-if="form.licenceType == 4"
            >
              <v-text-field
                v-model="form.device"
                label="Nombre dispositivo"
                placeholder="Todos"
              />
            </v-col>

            <v-col
              lg="3" md="6" sm="6" cols="12"
              v-if="form.licenceType == 4"
            >
              <v-select
                v-model="form.deviceType"
                :items="DeviceTypes"
                label="Tipo dispositivo"
                maxlength="11"
              />
            </v-col>

            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <v-btn
                :color="themeColor"
                class="white--text"
                style="margin-right:50px;"
                @click="getLicences()"
              >
                <i class="fas fa-file-download" /> Generar reporte
              </v-btn>
              <v-btn
                color="success"
                class="white--text"
                @click="downloadExcel()"
              >
                <i class="fas fa-download" /> Descargar Excel
              </v-btn>
            </v-col>
          </v-layout>
        </v-container>
      </v-form>
    </div>

    <v-col
      v-if="dowloading"
      class="subtitle-1 text-center"
      cols="12"
    >
      Cargando por favor espere...
    </v-col>
    <v-progress-linear
      indeterminate
      background-color="success"
      color="yellow darken-2"
      height="10"
      v-if="dowloading"
    ></v-progress-linear>

    <div class="col-12">
      <v-data-table
        v-if="licencias != 0"
        :headers="headers"
        :items="licencias"
        class="elevation-1"
      >
      <template v-slot:item.folios="{ item }">
        <span v-if="item.folios == null">0</span>
        <span v-else>{{item.folios}}</span>
      </template>
      <template v-slot:item.fecha_inicio="{ item }">
        <span v-if="item.fecha_inicio === null">Ninguna</span>
        <span v-else>{{item.fecha_inicio}}</span>
      </template>
      <template v-slot:item.fecha_fin="{ item }">
        <span v-if="item.fecha_fin === null">Ninguna</span>
        <span v-else>{{item.fecha_fin}}</span>
      </template>
      <template v-slot:item.active="{ item }">
        <span v-if="item.active === 1">Activo</span>
        <span v-else>Inactivo</span>
      </template>
      </v-data-table>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Form from 'vform';

Form.axios = window.axios;
export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('reportTransaction') };
  },
  data: () => ({
    form: new Form({
      rucCompany: '',
      ruc_distribuidor: '',
      estado: '2',
      dateStart: '',
      dateEnd: '',
      service_id: '0',
      device: '',
      busy: false,
      licenceType: '',
      deviceType: '',
      typePortal: 'D',
    }),
    apiURL: '/api/catalogs/getAllServices',
    licenceTypes: [
    { value: '1', text: 'Licencias' },
    { value: '4', text: 'Dispositivos' },
    ],
    estados: [
    { value: '1', text: 'Activo' },
    { value: '0', text: 'Inactivo' },
    { value: '2', text: 'Todos' },
    ],
    DeviceTypes: [
    { value: 'DBox', text: 'DBox' },
    { value: 'Caja Registradora', text: 'Caja Registradora' },
    { value: 'Dispositivo Móvil', text: 'Dispositivo Móvil' },
    ],
    valid: false,
    rules: {
      required: (v) => !!v || 'El campo es requerido.',
      numeric: (v) => /^([0-9])*$/.test(v) || 'El campo solo permite caracteres numericos.',
      format: (v) => /^(?=.*[0-9])/.test(v) || 'El campo solo permite caracteres numericos.',
      rucLength: (v) => ((v.length >= 5 && v.length <= 20) || v.length === 0) || 'El campo debe tener de 5 a 20 caracteres.',
      rucFormat: (v) => (/^(([P][E][-](([-]|[0-9]){1,17})|[N][-](([-]|[0-9]){1,18})|[E][-](([-]|[0-9]){1,18})|(([-]|[0-9]){5,20}))|(((([0-9]{1})[-][A][V][-](([-]|[0-9]){1,15}))|(([0-9]{2})[-][A][V][-](([-]|[0-9]){1,14})))|((([0-9]{1,2})[-][N][T][-](([-]|[0-9]){1,15}))|(([0-9]{1,2})[-][N][T][-](([-]|[0-9]){1,14}))|([N][T][-](([-]|[0-9]){1,14}))|(([0-9]{1,2})[-][P][I][-](([-]|[0-9]){1,14}))|([P][I][-](([-]|[0-9]){1,14}))|(([0-9]){1,2}[P][I][-](([-]|[0-9]){1,14})))))$/.test(v)
        || v.length === 0) || 'El campo debe tener un formato válido.',
    },
    startMenu: false,
    endMenu: false,
    allHeaders: [{
      text: 'Licencia',
      value: 'nombre',
      align: 'left',
      sortable: true,
    }, {
      text: 'Tipo dispositivo',
      value: 'typeDevice',
      align: 'left',
      sortable: true,
    }, {
      text: 'Fecha de Asignación',
      value: 'fecha',
      align: 'left',
      sortable: true,
    }, {
      text: 'RUC Emp',
      value: 'ruc',
      align: 'left',
      sortable: true,
    }, {
      text: 'Razón Social Emp',
      value: 'nombre_empresa',
      align: 'left',
      sortable: true,
    }, {
      text: 'Descripción Disp',
      value: 'nombre_dispositivo',
      align: 'left',
      sortable: true,
    }, {
      text: 'Marca Disp',
      value: 'marca',
      align: 'left',
      sortable: true,
    }, {
      text: 'ID Disp',
      value: 'id_dispositivo',
      align: 'left',
      sortable: true,
    }, {
      text: 'Tipo licencia',
      value: 'tipo',
      align: 'left',
      sortable: true,
    }, {
      text: 'Código licencia',
      value: 'codigo',
      align: 'left',
      sortable: true,
    }, {
      text: 'Folios',
      value: 'folios',
      align: 'left',
      sortable: true,
    }, {
      text: 'Folios (Utilizados)',
      value: 'folios_utilizados',
      align: 'left',
      sortable: true,
    }, {
      text: 'Cadencia',
      value: 'cadencia',
      align: 'left',
      sortable: true,
    }, {
      text: 'Fecha Inicio',
      value: 'fecha_inicio',
      align: 'left',
      sortable: true,
    }, {
      text: 'Fecha Fin',
      value: 'fecha_fin',
      align: 'left',
      sortable: true,
    }, {
      text: 'Fecha',
      value: 'flicence_dispositivo',
      align: 'left',
      sortable: true,
    }, {
      text: 'Fecha asignación',
      value: 'fecha_dispemp',
      align: 'left',
      sortable: true,
    }, {
      text: 'Estado',
      value: 'active',
      align: 'left',
      sortable: true,
    }],
    licencias: 0,
    dowloading: false,
    value: 0,
    query: false,
    show: false,
    licenciasAll: [],
    titulo: '',
    headers: [],
  }),
  computed: {
    ref() {
      return this.form.id;
    },
    ...mapGetters({
      user: 'auth/user',
      themeColor: 'theme/themeColor',
    }),
  },

  mounted() {
    this.selectLicencias();
    this.form.dateStart = this.getDate();
    this.form.dateEnd = this.getDate();

    if (!this.can('licencias_empresa')) {
      this.licenceTypes.splice(this.licenceTypes.findIndex(({ value }) => value === '1'), 1);
    }
    if (!this.can('dispositivos_empresa')) {
      this.licenceTypes.splice(this.licenceTypes.findIndex(({ value }) => value === '4'), 1);
    }
  },

  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        this.form.busy = true;
        this.valid = true;
      }
    },

    getLicences() {
      this.validate();
      if (this.$refs.form.validate()) {
        this.dowloading = true;
        let filteredFields = [];
        const url = '/api/reportLicences';
        this.form.post(url).then((response) => {
          this.licencias = response.data.items;
          this.headers = this.allHeaders;
          if (this.form.licenceType === '1') {
              filteredFields = ['Descripción Disp', 'Marca Disp', 'Fecha', 'ID Disp', 'Tipo dispositivo',
              'Fecha asignación'];
          } else if (this.form.licenceType === '4') {
              filteredFields = ['Fecha Inicio', 'Fecha Fin', 'Fecha', 'Folios', 'Folios (Utilizados)', 'RUC Emp', 'Licencia',
              'Código licencia', 'Cadencia', 'Tipo licencia', 'Razón Social Emp', 'Fecha asignación'];
          }

          this.headers = this.headers.filter((header) => filteredFields.indexOf(header.text) === -1);
          setTimeout(() => { this.dowloading = false; }, 500);
        })
        .catch(() => {
        });
      }
    },

    downloadExcel() {
        if (!this.licencias) {
          this.$store.dispatch('notifications/show', {
            message: 'El archivo Excel NO contiene registros que coincidan con los criterios de búsqueda.',
            type: 'error',
          });
        } else {
          this.dowloading = true;
          if (this.form.licenceType === '1') { this.titulo = 'Reporte de Licencias'; }
          if (this.form.licenceType === '4') { this.titulo = 'Reporte de Dispositivos'; }

          const url = '/api/download_excel_licences/export';
          window.axios({
            method: 'post',
            url,
            responseType: 'arraybuffer',
            data: this.form,
          }).then((response) => {
              this.downloadFile(response, this.titulo);
              setTimeout(() => { this.dowloading = false; }, 1000);
          })
          .catch(() => {
          });
        }
    },

    downloadFile(response, filename) {
      const newBlob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }
      const data = window.URL.createObjectURL(newBlob);
      const link = document.createElement('a');
      link.href = data;
      link.download = `${filename }.xlsx`;
      link.click();
      setTimeout(() => {
        window.URL.revokeObjectURL(data);
      }, 100);
    },

    selectLicencias() {
      window.axios.get(`/api/catalogs/dealers/${this.user.dealer_id}/licences`).then((response) => {
        this.licenciasAll = response.data.items;
        this.licenciasAll.push({
        id: '0',
        nombre: 'Todos',
        tiempo: '0',
        cadencia: '0',
        cantidad: '0',
        descripcion: '0',
        observaciones: '0',
        activo: '0',
        servicio: '0',
        created_at: '0',
        updated_at: '0',
        });
      });
    },
    getDate() {
        const date = new Date();
        const y = date.getFullYear();
        const m = (date.getMonth() + 1 < 10) ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const d = (date.getDate() < 10) ? `0${date.getDate()}` : date.getDate();
        const fecha = `${y}-${m}-${d}`;
      //  console.log(fecha);
        return fecha;
    },
  },
};
</script>
